import React, { Component } from 'react';

class WebRenderer extends Component {
    // static proptypes = {
    //     children: PropTypes.func.isRequired
    // }
    state = {
        mediaData: null
    }

    componentDidMount() {
        this.updateDataFromProps(this.props)
    }

    componentWillReceiveProps(props) {
        this.updateDataFromProps(props)
    }

    updateDataFromProps = (props) => {

        if (!props)
            return

        const { data = null } = props;

        this.setState({ mediaData: data });
    }

    render() {
        const { mediaData = null } = this.state;

        if (!mediaData) {
            return null;
        }

        const { UploadFile = "" } = mediaData;

        // console.log("UploadFile " + UploadFile)
        // const CORS_PROXY = "https://radiant-sands-32554.herokuapp.com/"


        const path = UploadFile;
        return (
            <iframe style={{ overFlow: "hidden" }} frameBorder="none" scrolling="no" ref={this.iframeRef} style={{ width: '100%', height: '100%', WebkitTransform: 'scale(1.01)' }} src={path} sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin"></iframe>
        )
    }
}

export default WebRenderer